module.exports = __webpack_public_path__ + "media/images/payments/ogone-dark-b6ebe3b4fee19a4cefa9dff70fe72318.svg";